import { NotificationDto } from '../service-trips-api/types/notification';

/**
 * All mock notifications point to the same passengerId (30013160)
 * so the link works in dev. When the real API is connected,
 * each notification will carry its own passengerId.
 */
export const MOCK_PASSENGER_ID = 30013160;

export const MOCK_NOTIFICATIONS: NotificationDto[] = [
  {
    id: '1a2b3c4d-0001-4000-a000-000000000001',
    passengerId: MOCK_PASSENGER_ID,
    passengerName: 'Lina Krebs',
    agreementName: 'Lidingö kommun',
    status: 'NEW_PASSENGER',
    createdAt: '2026-04-20T08:30:00Z',
    readAt: null,
  },
  {
    id: '1a2b3c4d-0002-4000-a000-000000000002',
    passengerId: MOCK_PASSENGER_ID,
    passengerName: 'Erik Johansson',
    agreementName: 'Stockholms stad',
    status: 'NEW_PASSENGER',
    createdAt: '2026-04-20T09:15:00Z',
    readAt: null,
  },
  {
    id: '1a2b3c4d-0003-4000-a000-000000000003',
    passengerId: MOCK_PASSENGER_ID,
    passengerName: 'Anna Lindqvist',
    agreementName: 'Lidingö kommun',
    status: 'AWAITING_APPROVAL',
    createdAt: '2026-04-19T14:00:00Z',
    readAt: null,
  },
  {
    id: '1a2b3c4d-0004-4000-a000-000000000004',
    passengerId: MOCK_PASSENGER_ID,
    passengerName: 'Oscar Bergström',
    agreementName: 'Stockholms stad',
    status: 'AWAITING_APPROVAL',
    createdAt: '2026-04-19T11:45:00Z',
    readAt: null,
  },
  {
    id: '1a2b3c4d-0005-4000-a000-000000000005',
    passengerId: MOCK_PASSENGER_ID,
    passengerName: 'Sara Nilsson',
    agreementName: 'Nacka kommun',
    status: 'NEW_PASSENGER',
    createdAt: '2026-04-18T16:20:00Z',
    readAt: '2026-04-19T08:00:00Z',
  },
  {
    id: '1a2b3c4d-0006-4000-a000-000000000006',
    passengerId: MOCK_PASSENGER_ID,
    passengerName: 'Karl Svensson',
    agreementName: 'Lidingö kommun',
    status: 'AWAITING_APPROVAL',
    createdAt: '2026-04-18T10:00:00Z',
    readAt: '2026-04-18T15:30:00Z',
  },
  {
    id: '1a2b3c4d-0007-4000-a000-000000000007',
    passengerId: MOCK_PASSENGER_ID,
    passengerName: 'Maria Ek',
    agreementName: 'Stockholms stad',
    status: 'NEW_PASSENGER',
    createdAt: '2026-04-17T13:00:00Z',
    readAt: null,
  },
  {
    id: '1a2b3c4d-0008-4000-a000-000000000008',
    passengerId: MOCK_PASSENGER_ID,
    passengerName: 'Johan Andersson',
    agreementName: 'Nacka kommun',
    status: 'AWAITING_APPROVAL',
    createdAt: '2026-04-17T09:30:00Z',
    readAt: null,
  },
  {
    id: '1a2b3c4d-0009-4000-a000-000000000009',
    passengerId: MOCK_PASSENGER_ID,
    passengerName: 'Elin Fransson',
    agreementName: 'Lidingö kommun',
    status: 'NEW_PASSENGER',
    createdAt: '2026-04-16T12:00:00Z',
    readAt: null,
  },
  {
    id: '1a2b3c4d-0010-4000-a000-000000000010',
    passengerId: MOCK_PASSENGER_ID,
    passengerName: 'Gustav Larsson',
    agreementName: 'Stockholms stad',
    status: 'AWAITING_APPROVAL',
    createdAt: '2026-04-16T08:45:00Z',
    readAt: '2026-04-16T14:00:00Z',
  },
  {
    id: '1a2b3c4d-0011-4000-a000-000000000011',
    passengerId: MOCK_PASSENGER_ID,
    passengerName: 'Hanna Ström',
    agreementName: 'Nacka kommun',
    status: 'NEW_PASSENGER',
    createdAt: '2026-04-15T15:30:00Z',
    readAt: null,
  },
  {
    id: '1a2b3c4d-0012-4000-a000-000000000012',
    passengerId: MOCK_PASSENGER_ID,
    passengerName: 'Lars Pettersson',
    agreementName: 'Lidingö kommun',
    status: 'AWAITING_APPROVAL',
    createdAt: '2026-04-15T10:15:00Z',
    readAt: null,
  },
];
